import {processApiRequest} from "../../Common/saga";
import * as ACTION from "../constants";
import apiService from "../apiService";

export function* fetchListWarehouse(action) {
	yield processApiRequest(ACTION.FETCH_LIST_WAREHOUSE, () => apiService.getListWarehouse(action.payload), action.payload);
}
